
<template>
  <div name="units">
    <noaccess v-if="!hasAccess" :blocktype="'outcome'"></noaccess>

    <div v-else>
    <FilterBar @searchChanged="setSearchValue">
      <template v-slot:filter>
        <div>
          <Dropdown
            :options="yearDropdown"
            :selected="filteredYear"
            :title="'Year Group'"
            v-on:updateOption="setYearValue"
            style="min-width: 12rem"
          ></Dropdown>
        </div>
        <dropdown
            :options="catDropdown"
            :selected="filteredCat"
            :title="'Unit Category'"
            v-on:updateOption="setCatValue"
            style="min-width: 15rem"
          >
            "></dropdown
          >
      </template>
      <template v-slot:actions>

      </template>
    </FilterBar>

      <p v-if="showMessage" class="save-notice">
        {{ msg }} <i class="far fa-check-circle"></i>
      </p>

    <table
      class="
        w-95p
        mx-auto
        mb-2
        h-10
        pt-2
        align-text-bottom
        bg-white
        rounded
        text-left text-gray-400
      "
    >

    <thead class="bg-gray-100 w-full">
        <tr>
          <th v-for="(col, index) in columns" :key="index" class="pl-2" v-bind:class="col.css" @click="sort(col.shortcode)">
            {{col.label}} 
            <i v-if="col.shortcode.length > 0" class="fas fa-sort tbh-sort " v-bind:class="col.shortcode === sortBy ? 'text-blue-500' : 'text-gray-400'" ></i>
          </th>
        </tr>
      </thead>
    </table>

    <div v-if="errored" class="empty">
      <p>
        We are not able to retrieve this information at the moment, please try
        back later
      </p>
    </div>

    <div id="content-area" v-else>
      <div
        style="width: 100%; text-align: center"
        class="spin-holder mt-4"
        v-if="loading"
      >
        <i class="spinner fa fa-spinner fa-spin"></i>
        <p>Loading Units</p>
      </div>

      <div v-else>
        <table
          v-if="componentLoaded"
          class="table-wrapper w-95p bg-white mx-auto rounded shadow-sm"
        >
          <tbody>
            <tr class="course" v-for="item in filteredList" :key="item.id">
              <td class="w-2/12">
                 <div class="pl-3">
                  {{ parseYeaGroup(item.year_id) }}
                </div>
              </td>
              <td class="w-4/12">
                <strong>{{ item.name }}</strong>
              </td>
              <td class="w-3/12">
                  {{ parseCategory(item.category_id) }}
        
              </td>
              <td class="w-1/12 tb-actions" align="center" >
                <a v-on:click="showOutcomeModal(item)" class="text-button blue-text hover:opacity-50"
                  >Outcomes</a
                >
                
              </td>

    
            </tr>
          </tbody>
          <tfoot></tfoot>
        </table>

        <p class="ml-10 mt-6 text-sm" v-else>
          We could not find any data for your given selection.
        </p>

        <ModalSlide
        :show="showOutcomes"
        :cssWidth="'md:w-7/12'"
        @closeModal="showOutcomes = false"
      >
        <template v-slot:header-icon>
          <i class="fas fa-edit"></i>
        </template>
        <template v-slot:header-title>
          {{selectedCourse.name}} outcomes
          <div class="text-xs">Add or remove outcomes to display within the unit</div>
        </template>
        <template v-slot:body>
          <Outcomeapply
          @refresh="refreshList"
          :subject="subject"
          :course="selectedCourse"
          :years="years"
          ref="outcomeApply"
          v-if="showOutcomes"
        ></Outcomeapply>
        </template>
      </ModalSlide>
  


      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment'
const ModalSlide = () => import("@/components/ModalSlide.vue");

const Dropdown = () => import("@/components/Dropdown.vue");
const FilterBar = () => import("@/components/FilterBarNavigation.vue");
const noaccess = () => import("@/components/NoAccess.vue");
const Outcomeapply = () => import("@/components/customunit/OutcomeApply.vue");
import { SchoolService, BaseService } from "@/services/school.service";
import { yearGroupMixin} from "@/mixins/yearGroupMixin.js";

export default {
  name: "units",
  mixins: [yearGroupMixin],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings",

    }),
    componentLoaded() {
      return this.orderedUnits.length > 0;
    },
    hasAccess() {
      return this.currentAccess.outcomeAccess || this.currentUser.isOrganisation
    },
    yearDropdown() {
      var results = [{ id: 0, name: "All" }].concat(
        this.years
      );
      this.filteredYear = results[0];
      return results;
    },
    catDropdown() {
      var results = [{ id: 0, name: "All" }].concat(
        this.cats
      );
      this.filteredCat = results[0];
      return results;
    },
    orderedUnits() {
      var vm = this;
      var category = vm.filteredCat;
      let year = vm.filteredYear;


      if (year.id == 0 && category.id == 0) {
        return this.units
      } else {
        return vm.units.filter(function (unit) {
          let filtered = true;

          if (year.id > 0) {
            filtered = unit.year_id === year.id;
          }

          if (filtered) {
            if (category.id > 0) {
              filtered = unit.category_id === category.id;
            }
          }
          return filtered;
        });
      }
    },
    filteredList() {
      let vm = this
      var results = this.orderedUnits.filter((item) => {
       return item.name.toLowerCase().includes(vm.search.toLowerCase());
      });
      return _.orderBy(results, [vm.sortBy], [vm.sortDirection]);
    },
  },
  data() {
    return {
      loading: true,
      errored: false,
      showFilter: false,
      showOutcomes: false,
      showMessage: false,
      units: [],
      cats: [],

      selectedCourse: {},
      filteredYear: {},
      filteredCat: {},
      search: "",

      sortBy: 'year_id',
      sortDirection: 'asc',

      columns: [
                { label: 'Year Group', shortcode: 'year_id', css: 'w-2/12 pl-3' },
                { label: 'Unit Title', shortcode: 'name', css: 'w-4/12 text-left' },
                { label: 'Category', shortcode: 'category.name', css: 'w-3/12' },
                { label: '', shortcode: '', css: 'w-1/12' },
            ], // columns
    };
  },
  created() {
    this.loading = true;

    // cats
    BaseService.getAll("categories")
      .then((response) => this.buildCategoryList(response.data.data))
      .catch((res) => {
        console.log(res);
      });
    this.fetchData();
  },
  mounted() {

  },
  methods: {
    fetchData() {
      let date = moment().subtract(2, 'years');
      console.log(date)
   
      SchoolService.getAll("planning?since=" +  moment(date, "YYYY-MM-DD"))
        .then((response) => this.buildUnitList(response.data.data))
        .catch((err) => {
          console.log("Courses " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    buildUnitList(data) {
      let results = data.flatMap(element => {
        if (element.is_deleted === 0 && element.display_box > 0) {
          return element.course
        } 
      });

      this.units = results.filter((u) => u != undefined)
    },
    buildCategoryList(data) {
      this.cats = data;
    },
    refreshUnits() {
      this.fetchData();
    },
    sort(s) {
      if (s === this.sortBy) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      }
      this.sortBy = s;
    },
    showOutcomeModal(unit) {
      this.selectedCourse = unit
      this.showOutcomes = true
    },
    setCatValue(cat) {
      this.filteredCat = cat;
    },
    showCommunity() {
      this.$router.push({ path: "community" });
    },
    setFilter() {
      this.showFilter = !this.showFilter;
      if (this.showFilter == false) {
        this.filteredYears = [];
      }
    },
    setSearch() {
      this.showSearch = !this.showSearch;
      this.search = "";
    },
    setYearValue(value) {
      this.filteredYear = value
    },
    setSearchValue(value) {
      this.search = value;
    },
    refreshList() {
      this.loading = true
      this.fetchData()
      this.showOutcomes = false;
    },
    parseCategory(categoryId) {
      let cat = this.cats.find((c) => c.id === categoryId)
      return cat != undefined ? cat.name : "Unknown"
    },
    parseYeaGroup(yearId) {
      let year = this.years.find((c) => c.id === yearId)
      return year != undefined ? year.name : "Unknown"
    }
  },
  components: {
    Dropdown,
    FilterBar,
    noaccess,
    Outcomeapply,
    ModalSlide
  },
};
</script>


<style scoped>
.trash {
  cursor: pointer;
}
</style>
